import { render, staticRenderFns } from "./shenRepairVehicleDetail.vue?vue&type=template&id=56a2d318&"
import script from "./shenRepairVehicleDetail.vue?vue&type=script&lang=js&"
export * from "./shenRepairVehicleDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenRepairVehicleDetail.vue?vue&type=style&index=0&id=56a2d318&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports